import React from "react";
import { withStyles } from "@material-ui/core";
import DataGrid from '@dataGrid';
import StatusBar from '@dataGrid/components/StatusBar';
import GridConfig from "./gridConfig";
import appConstants from "../../../../../appConstants";
import { compose } from "recompose";
import { withFeatureFlags } from "../../../../../userProfile/featureFlagsContext";

import { DateTimeEditor } from '@dataGrid/components/cellEditors';
import { formatMonthDateYear } from '@dataGrid/gridUtilities';
import ClearAllFilterButton from '@dataGrid/components/columnFilters/ClearAllFilterButton';
const styles = (theme) => ({
  header: {
    color: theme.palette.primary.main,
    padding: "4px 16px",
    fontSize: 16,
    display: "flex",
    alignItems: "center",
  },
  headerText: {
    marginRight: "16px",
    fontWeight: 600,
    fontSize: 16,
    color: theme.palette.primary.main,
  },
  complianceGridContainer: {
    boxSizing: "border-box",
    margin: "0px 16px",
    border: `1px solid ${theme.AppBGColor}`,
    height: "calc(100% - 40px)",
    [`&>.gridTheme-${theme.themeName}`]: {
      height: "100%",
    },
  },
  clearAllFilterButton: {
    marginLeft: "auto"
  }
});

class DockComplianceGrid extends React.Component {
  constructor(props) {
    super(props);
    this.gridConfig = new GridConfig({
      featureFlags:{ IsWeightBasedRoutingEnabled: this.props.featureFlags.isFeatureEnabled(appConstants.features.isWeightBasedRouting)}
    });
    this.gridApi = null;
    this.state = {
      filterData: "",
    };
  }

  onGridReady = ({ api }) => {
    this.gridApi = api;
    if (this.props.selectedPlannedRoute && this.props.selectedGateoutRoute) {
      this.gridApi.forEachNode((node) => {
        if (
          node.data.rmaxRoute === this.props.selectedPlannedRoute &&
          node.data.routeName === this.props.selectedGateoutRoute
        ) {
          node.setSelected(true);
          return;
        }
      });
    }
  };

  updateGridData = (updatedFilterData) => {
    this.setState(
      {
        filterData: updatedFilterData,
      },
      () => this.gridApi.onFilterChanged()
    );
  };

  doesExternalFilterPass = (node) => {
    switch (this.state.filterData) {
      case "plannedRoutes":
        return (
          node.data.plannedRoute !== null &&
          node.data.plannedRoute !== "None" &&
          node.data.plannedRoute !== "Unplanned"
        );
      case "dispatchedRoutes":
        return (
          node.data.dispatchedRoute !== null &&
          node.data.dispatchedRoute !== "None"
        );
      case "compliantRoutes":
        return node.data.compliancePercentage === 100;
      default:
        return true;
    }
  };

  constructStatusBar = (complianceData) => {
    const plannedRoutes = complianceData
      ? complianceData.filter(
          (data) =>
            data.plannedRoute !== null &&
            data.plannedRoute !== "None" &&
            data.plannedRoute !== "Unplanned"
        ).length
      : 0;
    const dispatchedRoutes = complianceData
      ? complianceData.filter(
          (data) =>
            data.dispatchedRoute != null && data.dispatchedRoute !== "None"
        ).length
      : 0;
    const compliantRoutes = complianceData
      ? complianceData.filter((data) => data.compliancePercentage === 100)
          .length
      : 0;

    const statusBarData = [
      {
        label: complianceData?.length + " Routes",
        filterCondition: "",
      },
      {
        label: plannedRoutes + " Planned Routes",
        filterCondition: "plannedRoutes",
      },
      {
        label: dispatchedRoutes + " Dispatched Routes",
        filterCondition: "dispatchedRoutes",
      },
      {
        label: compliantRoutes + " Compliant Routes",
        filterCondition: "compliantRoutes",
      },
    ];
    return statusBarData;
  };

  navigateToSelectedManifest = (params) => {
    const selectedRows = params.api.getSelectedRows();
    const route = selectedRows.length ? selectedRows[0] : null;
    this.props.onSelected && this.props.onSelected(route);
  };
  onSelectionChanged = (params) => {
    params.data.compliancePercentage >= appConstants.DCR_DRILLDOWN_COMPLIANCE &&
      this.navigateToSelectedManifest(params);
  };
  onCellClicked = (params) => {
    if (
      params.column.colId === "manifestNumber" &&
      params.data.compliancePercentage >= appConstants.DCR_DRILLDOWN_COMPLIANCE
    ) {
      this.navigateToSelectedManifest(params);
    }
  };

  render() {
    const { complianceData, classes } = this.props;
    const planDate = formatMonthDateYear({
      value: this.props.planDate,
    });
    return (
      <React.Fragment>
        <header className={classes.header}>
          <span className={classes.headerText}>
            Planned trailer load vs Dispatched trailer load
          </span>
          <DateTimeEditor
            dateType={appConstants.DATETYPES.MONTHDATEYEAR}
            onChange={this.props.onDateChanged}
            disableFuture={true}
            value={planDate}
          />
          <div className={classes.clearAllFilterButton}>
            <ClearAllFilterButton gridApi={this.gridApi}/>
          </div>
        </header>
        <div className={classes.complianceGridContainer}>
          <DataGrid
            defaultColDef={this.gridConfig.config.defaultColDef}
            columnDefs={this.gridConfig.config.columns}
            config={this.gridConfig.config}
            onGridReady={this.onGridReady}
            enableFilter={this.gridConfig.config.enableFilter}
            rowData={complianceData}
            panelLabel={ (complianceData) => <StatusBar data={this.constructStatusBar(complianceData)} filterGridData={this.updateGridData}/> }
            onCellClicked={this.onCellClicked}
            onCellDoubleClicked={this.onSelectionChanged}
            isExternalFilterPresent={() => Boolean(this.state.filterData)}
            doesExternalFilterPass={this.doesExternalFilterPass}
          />
        </div>
      </React.Fragment>
    );
  }
}

export default compose(withStyles(styles), withFeatureFlags)(DockComplianceGrid);
